import React, { useState, useEffect } from 'react';
import ImgAgent_master from '../data/master_agent.png';



const AgentCommentMaster = ({title, comment}) => {
  
  return (
    <div style={styles.container}>
      <img src={ImgAgent_master} alt="Agent" style={styles.image} />
      <div style={styles.textContainer}>
        <h2 style={styles.title}>{title}</h2>
        <p style={styles.description}>{comment}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',           // 가로 길이를 전체로 설정
    padding: '20px',
    border: 'none',           // 테두리 제거
    borderRadius: '8px',
  },
  image: {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '8px',
    marginRight: '20px',
  },
  textContainer: {
    flex: 1,
  },
  title: {
    fontSize: '16px',         // 타이틀 폰트 크기 줄이기
    fontWeight: 'bold',
    color: 'gray',            // 타이틀 색상을 회색으로 변경
    margin: 0,
  },
  description: {
    fontSize: '16px',
    marginTop: '7px',
  },
};

export default AgentCommentMaster;